import React, { useState } from 'react';
import styled from 'styled-components';
import { ConnectButtonCustom } from './ConnectButtonCustom';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 40px;
  background: transparent;
  gap: 15px;
  width: 100%;
`;

const NavItem = styled.div`
  font-size: 14px;
  color: white;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.4); 
  border-radius: 20px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.05);
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.8);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100; 
`;

/* --- STYLED COMPONENTS UNTUK HISTORY --- */
const HistoryModalContent = styled.div`
  background: #0a000f;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 30px;
  width: 90%;
  max-width: 1000px;
  position: relative;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 25px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 28px;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: white;
  }
`;

const TableGrid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1fr 1.1fr 1.2fr 1.1fr 1.1fr;
  gap: 0.75rem;
  align-items: center;
`;

const TableHeader = styled(TableGrid)`
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  margin-bottom: 8px;
`;

const Th = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  font-weight: 500;
`;

const TableBodyWrapper = styled.div`
  border: 1px solid #a855f7; 
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.5); 
  margin-top: 20px;
  display: flex;
  flex-direction: column;
`;

const TableRow = styled(TableGrid)`
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05); 
  transition: background-color 0.2s;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.05); 
  }
`;

const Td = styled.div`
  color: white;
  font-size: 14px;
`;

const EligibleBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  background: rgba(34, 197, 94, 0.2); 
  color: #4ade80; 
  border: 1px solid rgba(34, 197, 94, 0.3); 
`;

/* --- STYLED COMPONENTS UNTUK FAQ --- */
const FaqModalContent = styled.div`
  background: rgba(255, 255, 255, 0.15);
  border-radius: 40px;
  padding: 24px;
  backdrop-filter: blur(24px);
  width: min(986px, calc(100vw - 30px));
  max-height: 90vh;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow-y: auto;
  position: relative;
`;

const FaqHeaderWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
`;

const FaqTitleBox = styled.div`
  width: calc(100% - 55px);
  flex: none;
  background: white;
  height: 44px;
  margin-bottom: -2px; 
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #7246CE;
`;

const FaqCurveContainer = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  left: -1.25px;
  flex: none;
`;

const FaqCloseBtnWrapper = styled.div`
  width: 48px;
  height: 48px;
  flex: none;
  position: relative;
  left: -18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FaqCloseButton = styled.button`
  width: 32px;
  height: 32px;
  background: #7246CE;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: none;
  cursor: pointer;
`;

const FaqInnerClose = styled.div`
  background: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: relative;
  transform: scale(0.6);
`;

const FaqListContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 32px;
  border-top-left-radius: 0;
  padding: 20px;
  margin: 0 auto;
  background: white;
  gap: 16px;
`;

const FaqItem = styled.div`
  border-radius: 9999px;
  background: #F6F8FA;
  border: 1px solid #E2E4E9;
  overflow: hidden;
`;

const FaqItemBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  font-weight: bold; /* Teks Bold */
  background: transparent;
  border: none;
  color: #7246CE; /* Warna Hex #7246ce */
  cursor: pointer;
  text-align: left;
`;

export const Header: React.FC = () => {
  const [showHistory, setShowHistory] = useState(false);
  const [showFaq, setShowFaq] = useState(false);

  return (
    <>
      <HeaderContainer>
        <NavItem onClick={() => setShowFaq(true)}>FAQ</NavItem>
        <NavItem onClick={() => setShowHistory(true)}>Claim History</NavItem>
        <ConnectButtonCustom />
      </HeaderContainer>

      {/* --- MODAL CLAIM HISTORY --- */}
      {showHistory && (
        <ModalOverlay onClick={() => setShowHistory(false)}>
          <HistoryModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => setShowHistory(false)}>&times;</CloseButton>
            
            <TableHeader>
              <Th>Airdrop Phase</Th>
              <Th>Allocation</Th>
              <Th>Claimed</Th>
              <Th>Remaining</Th>
              <Th>Claim Status</Th>
              <Th>Distribution</Th>
              <Th>Claim Date</Th>
              <Th>Action</Th>
            </TableHeader>

            <TableBodyWrapper>
              <TableRow>
                <Td style={{ textAlign: 'center' }}>Early Contributor</Td>
                <Td style={{ fontWeight: 500 }}>-</Td>
                <Td style={{ fontWeight: 500 }}>-</Td>
                <Td style={{ fontWeight: 500 }}>-</Td>
                <Td>
                  <EligibleBadge>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6L5 9L10 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Eligible
                  </EligibleBadge>
                </Td>
                <Td>-</Td>
                <Td>-</Td>
                <Td>-</Td>
              </TableRow>
              <TableRow>
                <Td style={{ textAlign: 'center' }}>Rep Era Airdrop</Td>
                <Td style={{ fontWeight: 500 }}>-</Td>
                <Td style={{ fontWeight: 500 }}>-</Td>
                <Td style={{ fontWeight: 500 }}>-</Td>
                <Td>
                  <EligibleBadge>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6L5 9L10 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Eligible
                  </EligibleBadge>
                </Td>
                <Td>-</Td>
                <Td>-</Td>
                <Td>-</Td>
              </TableRow>
              <TableRow>
                <Td style={{ textAlign: 'center' }}>Cookie</Td>
                <Td style={{ fontWeight: 500 }}>-</Td>
                <Td style={{ fontWeight: 500 }}>-</Td>
                <Td style={{ fontWeight: 500 }}>-</Td>
                <Td>
                  <EligibleBadge>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6L5 9L10 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Eligible
                  </EligibleBadge>
                </Td>
                <Td>-</Td>
                <Td>-</Td>
                <Td>-</Td>
              </TableRow>
            </TableBodyWrapper>

          </HistoryModalContent>
        </ModalOverlay>
      )}

      {/* --- MODAL FAQ --- */}
      {showFaq && (
        <ModalOverlay onClick={() => setShowFaq(false)}>
          <FaqModalContent onClick={(e) => e.stopPropagation()}>
            <FaqHeaderWrapper>
              <FaqTitleBox>FAQ</FaqTitleBox>
              
              <FaqCurveContainer>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 60" preserveAspectRatio="xMidYMid meet" style={{width: '100%', height: '100%'}}>
                  <path d="M0 0 C0.33 0 0.66 0 1 0 C1.08636719 0.87140625 1.17273438 1.7428125 1.26171875 2.640625 C2.26846554 11.17488216 4.15762163 18.31524327 8 26 C8.43183594 26.86367188 8.86367187 27.72734375 9.30859375 28.6171875 C16.59664952 41.87195181 28.82274533 51.41716666 43.07421875 56.22265625 C48.30930832 57.61355455 53.62880062 58.35101566 59 59 C59 59.33 59 59.66 59 60 C39.53 60 20.06 60 0 60 C0 40.2 0 20.4 0 0 Z " fill="#FFFFFF" transform="translate(0,4)"></path>
                </svg>
              </FaqCurveContainer>

              <FaqCloseBtnWrapper>
                <FaqCloseButton onClick={() => setShowFaq(false)}>
                   <FaqInnerClose>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" style={{fill: '#7246CE', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>
                         <path d="M8 7.111 3.555 2.667l-.888.888L7.11 8l-4.444 4.445.888.888L8 8.89l4.445 4.444.888-.888L8.89 8l4.444-4.445-.888-.888z"></path>
                      </svg>
                   </FaqInnerClose>
                </FaqCloseButton>
              </FaqCloseBtnWrapper>
            </FaqHeaderWrapper>

            <FaqListContainer>
              {[
                "What is the $FORU Token?",
                "Who is eligible to claim the $FORU airdrop?",
                "What are the eligible requirements to claim $FORU airdrop?",
                "What is the deadline to claim the $FORU airdrop?",
                "After claiming the Airdrop rewards, how can I check the received $FORU tokens?"
              ].map((question, index) => (
                <FaqItem key={index}>
                  <FaqItemBtn>
                    <span>{question}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8.00001 11.1999C7.53335 11.1999 7.06668 11.0199 6.71335 10.6666L2.36668 6.31993C2.17335 6.12659 2.17335 5.8066 2.36668 5.61326C2.56001 5.41993 2.88001 5.41993 3.07335 5.61326L7.42001 9.95993C7.74001 10.2799 8.26001 10.2799 8.58001 9.95993L12.9267 5.61326C13.12 5.41993 13.44 5.41993 13.6333 5.61326C13.8267 5.8066 13.8267 6.12659 13.6333 6.31993L9.28668 10.6666C8.93335 11.0199 8.46668 11.1999 8.00001 11.1999Z" fill="currentColor"></path>
                    </svg>
                  </FaqItemBtn>
                </FaqItem>
              ))}
            </FaqListContainer>

          </FaqModalContent>
        </ModalOverlay>
      )}
    </>
  );
};